import React from 'react';
import Loader from '../components/common/Loader';
import StartButton from '../components/home5_residence/StartButton';
import Menu from '../components/home5_residence/Menu';
import Navbar from '../components/home5_residence/Navbar';
import Header from '../components/home5_residence/Header';
import About from '../components/home5_residence/About';
import Flawless from '../components/home5_residence/Flawless';
import Location from '../components/home5_residence/Location';
import FloorPlans from '../components/home5_residence/FloorPlans';
import GoogleMap from '../components/home5_residence/GoogleMap';
import Apartments from '../components/home5_residence/Apartments';
// import Testimonials from '../components/home5_residence/Testimonials';
import Spacer from '../components/home5_residence/Spacer';
// import Blog from '../components/home5_residence/Blog';
import Footer from '../components/home5_residence/Footer';
import { Helmet } from 'react-helmet';


function Home5() {
return (
<>
  <Helmet>
    <link rel="stylesheet" type="text/css" href="/home5_residence/assets/css/home_5_style.css" />

    <script src="/common/assets/js/common_js.js"></script>
    <script src="/home5_residence/assets/js/home_5_scripts.js"></script>


  </Helmet>

  <body className="home-style5">
    <Loader />
    <Menu />
    <div className="smooth-scroll-content" id="scrollsmoother-container">
      <Navbar />
      <Header />
      <main>
        <About />
        <Flawless />

        <section style={{ marginBottom: '100px'}}>

          <div className="container">

            <div className="row">

              <div className="col-md-6" style={{ padding: '15px'}}>
                <div className="card image_card_style">
                  <img src="/home5_residence/assets/images/flowless/kitchen.jpg" className="card-img-top img-fluid"
                    alt="Kitchen Image" />
                  <div className="card-body">
                    <h5 className="card-title" style={{ color: 'black' }}> Kitchen Area </h5>
                  </div>
                </div>
              </div>


               <div className="col-md-6" style={{ padding: '15px'}}>
                <div className="card image_card_style">
                  <img src="/home5_residence/assets/images/flowless/living.jpg" className="card-img-top img-fluid"
                    alt="Kitchen Image" />
                  <div className="card-body">
                    <h5 className="card-title" style={{ color: 'black' }}> Living Area </h5>
                  </div>
                </div>
              </div>


               <div className="col-md-6" style={{ padding: '15px'}}>
                <div className="card image_card_style">
                  <img src="/home5_residence/assets/images/flowless/bath.jpg" className="card-img-top img-fluid"
                    alt="Kitchen Image" />
                  <div className="card-body">
                    <h5 className="card-title" style={{ color: 'black' }}> Bath Area </h5>
                  </div>
                </div>
              </div>

               <div className="col-md-6" style={{ padding: '15px'}}>
                <div className="card image_card_style">
                  <img src="/home5_residence/assets/images/flowless/outdoor.jpg" className="card-img-top img-fluid"
                    alt="Kitchen Image" />
                  <div className="card-body">
                    <h5 className="card-title" style={{ color: 'black' }}> Outdoor Area </h5>
                  </div>
                </div>
              </div>
              

            </div>

          </div>


        </section>

        <Location />
        <FloorPlans />
        {/*
        <Apartments /> */}
        {/*
        <Testimonials /> */}
        {/*
        <Services /> */}
        <Spacer />
        <GoogleMap />
        {/*
        <Blog /> */}
      </main>
      <Footer />
    </div>
    <StartButton />
  </body>
</>
);
}

export default Home5;